import { TextAa } from "@phosphor-icons/react";
import { SectionShell, Panel } from "../Primitives";
import { TYPE_SCALE } from "@/data/designTokens";

function FontCard({ name, role, family, weights, specimen, className }) {
  return (
    <Panel>
      <div className="flex items-baseline justify-between">
        <p className="text-sm font-bold uppercase tracking-wider text-muted-foreground">{role}</p>
        <span className="rounded-full bg-muted px-3 py-1 text-xs font-bold text-muted-foreground">{weights}</span>
      </div>
      <p className={`mt-3 leading-none ${className}`} style={{ fontFamily: family }}>
        {specimen}
      </p>
      <p className="mt-4 font-display text-xl font-extrabold">{name}</p>
      <p className="mt-1 font-medium text-muted-foreground" style={{ fontFamily: family }}>
        The quick brown fox jumps over 12 lazy dogs.
      </p>
    </Panel>
  );
}

export function TypographySection() {
  return (
    <SectionShell
      id="typography"
      eyebrow="Typography"
      eyebrowIcon={TextAa}
      title="Rounded, legible, grown-up friendly"
      description="Two soft, humanist sans-serifs do the work. Nunito brings playful confidence to headings; Quicksand keeps body text gentle and exceptionally readable for early readers and dyslexic children alike."
    >
      <div className="grid gap-5 md:grid-cols-2">
        <FontCard
          name="Nunito"
          role="Display & headings"
          family="Nunito, sans-serif"
          weights="700 – 900"
          specimen="Aa"
          className="text-7xl font-black tracking-tight"
        />
        <FontCard
          name="Quicksand"
          role="Body & UI"
          family="Quicksand, sans-serif"
          weights="400 – 700"
          specimen="Aa"
          className="text-7xl font-bold tracking-tight"
        />
      </div>

      <div className="mt-6 overflow-hidden rounded-3xl border border-border bg-card shadow-soft">
        {TYPE_SCALE.map((t, i) => (
          <div
            key={t.token}
            className={`flex flex-col gap-2 px-6 py-5 md:flex-row md:items-center md:gap-6 ${
              i !== 0 ? "border-t border-border" : ""
            }`}
          >
            <div className="w-32 flex-shrink-0">
              <p className="text-sm font-bold uppercase tracking-wider text-primary-strong">{t.token}</p>
              <p className="text-xs font-semibold text-muted-foreground">{t.note}</p>
            </div>
            <p className={`min-w-0 flex-1 truncate ${t.cls}`}>{t.sample}</p>
          </div>
        ))}
      </div>

      <p className="mt-6 max-w-2xl font-medium leading-relaxed text-muted-foreground">
        Body copy never drops below <strong className="text-foreground">16px</strong>, with generous{" "}
        <strong className="text-foreground">1.6 line-height</strong>. As children mature, screens lean on lighter
        weights and tighter scales — never smaller than comfortable.
      </p>
    </SectionShell>
  );
}

export default TypographySection;
